"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExpiredSync = exports.isExpired = exports.isExpirable = void 0;
const effect_1 = require("effect");
const isExpirable = (consumable) => consumable.subset.constructor.expirable;
exports.isExpirable = isExpirable;
exports.isExpired = effect_1.Effect.fn('isExpired')(function* (consumable) {
    const expiresAt = yield* effect_1.Schema.decode(effect_1.Schema.DateTimeUtcFromDate)(consumable.state.expiresAt);
    const expiresInFuture = yield* effect_1.DateTime.isFuture(expiresAt);
    return !expiresInFuture;
});
/**
 * See {@link isExpired}
 */
const isExpiredSync = (...args) => effect_1.Effect.runSync((0, exports.isExpired)(...args));
exports.isExpiredSync = isExpiredSync;
//# sourceMappingURL=expirable.js.map